import React, { useContext, useEffect, useState } from "react";

import { Helmet } from "react-helmet";

import checkoutSteps from "../../../../../providers/ElectricityCheckoutSteps";
import { DataContext } from "../../../../../providers/ElectricityDataProvider";
import CalculatorProductDetails from "../../../../shared/CalculatorProductDetails";
import CalculatorProducts from "../../../../shared/CalculatorProducts";
import { navigate } from "../../../../shared/LinkComponent";
import LoadingIndicator from "../../../../shared/LoadingIndicator";
import Product from "./Product";
import UnsupportedConsumption from "./UnsupportedConsumption";

const CalculatorResult = () => {
    const dataContext = useContext(DataContext);
    const {
        result,
        loading,
        consumption,
        productChoice,
        validResult,
        maxConsumptionError,
    } = dataContext.data;
    const { setProductChoice, clearCheckout, setTariffId, setTariffCode } =
        dataContext.actions;

    const [products, setProducts] = useState(undefined);
    const [expanded, setExpanded] = useState([]);

    const isExpanded = (itemIndex) => {
        return expanded.includes(itemIndex);
    };

    const toggleExpand = (itemIndex) => {
        if (isExpanded(itemIndex)) {
            setExpanded(expanded.filter((item) => item !== itemIndex));
        } else {
            setExpanded([...expanded, itemIndex]);
        }
    };

    useEffect(() => {
        setExpanded([]);
    }, [result]);

    useEffect(() => {
        if (result?.length > 0) {
            setProducts(
                result.filter((product) => !product.isGrundversorgungsTarif)
            );
        } else {
            setProducts(undefined);
        }
    }, [result]);

    return (
        <div>
            <Helmet>
                <title>Strom von Hoyer ▷ Jetzt Stromanbieter wechseln</title>
                <meta
                    name="description"
                    content="Top im Stromvergleich ▷ Bester Service & attraktive Konditionen"
                />
            </Helmet>
            {loading && <LoadingIndicator></LoadingIndicator>}
            {validResult && (
                <React.Fragment>
                    <CalculatorProducts
                        products={products}
                        activeIndex={productChoice}
                        onIndexChange={setProductChoice}
                        validResult={validResult}
                        showTotalPriceLabel
                    />
                    <CalculatorProductDetails activeIndex={productChoice}>
                        {products &&
                            products.map((product, idx) => (
                                <Product
                                    key={idx}
                                    product={product}
                                    consumption={consumption}
                                    expanded={isExpanded(idx)}
                                    onExpand={() => toggleExpand(idx)}
                                    onSubmit={() => {
                                        setProductChoice(idx);
                                        let url = checkoutSteps[0].url;
                                        setTariffId(product.tarifID);
                                        setTariffCode(product.tarifCode);
                                        clearCheckout();
                                        setTimeout(
                                            () =>
                                                navigate(
                                                    "/strom/bestellung/" + url
                                                ),
                                            0
                                        );
                                    }}
                                />
                            ))}
                    </CalculatorProductDetails>
                </React.Fragment>
            )}
            {maxConsumptionError && <UnsupportedConsumption />}
        </div>
    );
};

export default CalculatorResult;
